import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "idle", "processing"]

  connect() {
    this.reset()
  }

  submit(event) {
    if (this.submitted || !this.hasButtonTarget) return

    event.preventDefault()
    this.submitted = true

    this.buttonTarget.disabled = true
    this.buttonTarget.classList.add("animate-pulse-strong", "pointer-events-none", "cursor-not-allowed")
    this.idleTarget.classList.add("hidden")
    this.processingTarget.classList.remove("hidden")

    // Force the browser to paint the processing state before the native submit
    // navigates away — without this, a fast response can skip the repaint entirely.
    requestAnimationFrame(() => requestAnimationFrame(() => this.element.requestSubmit()))
  }

  reset() {
    if (!this.hasButtonTarget) return

    this.submitted = false
    this.buttonTarget.disabled = false
    this.buttonTarget.classList.remove("animate-pulse-strong", "pointer-events-none", "cursor-not-allowed")
    this.idleTarget.classList.remove("hidden")
    this.processingTarget.classList.add("hidden")
  }
}
